module.exports = __webpack_public_path__ + "img/articulos6.bae2070b.png";